import React from "react";

import { UserReviewFragment } from '../../graphql/generated/definitions';

import useTranslations from "../../hooks/useTranslations";
import UserAvatar from "../utils/avatars/UserAvatar";
import { Link, ScreenHeader } from "../wombat-ui";

type UserHeaderProps = {
  user: UserReviewFragment;
};

const UserHeader: React.FC<UserHeaderProps> = ({ user }) => {
  const t = useTranslations();


  return (
    <ScreenHeader
      title={user.name}
      renderIcon={(size) => (
        <UserAvatar
          src={user.avatar}
          alt="user avatar"
          size={size}
        />
      )}
      description={
        <>
          <a
            className="text-sm text-primary-500"
            href={`mailto:${user.email}`}
          >
            {user.email}
          </a>
          <p className="text-xs">
            {t("collaborator.registeredOn", {
              date: new Date(user.createdAt).toLocaleDateString(),
            })}
          </p>
        </>
      }
      actions={[
        user.canInsert && (
          <Link
            key="editUserLink"
            to={`/users/${user.slug}/edit`}
            variant="button"
          >
            {t("forms.actions.edit")}
          </Link>
        )
      ]}
    />
  )
};

export default UserHeader;
